import { useState } from "react";

// Components
import Button from "components/Common/Button/Button";
import TextArea from "components/Common/TextArea/TextArea";
import Alert from "components/Common/Alert/Alert";

// Utils
import * as Database from "utils/database.utils";
import { toAnalyticsDate } from "utils/general.utils";

// Styles
import IgnoreExtractionModalContainer from "./IgnoreExtractionModal.styles";

type Props = {
    id: string;
    extraction_datetime: Date;
    processing_datetime: Date;
    setShowModal: Function;
    reload: Function;
};

export default function IgnoreExtractionModal({
    id,
    extraction_datetime,
    processing_datetime,
    setShowModal,
    reload,
}: Props) {
    const [notes, setNotes] = useState<string>("");
    const [showNotes, setShowNotes] = useState<boolean>(false);

    const [mode, setMode] = useState<
        "DEFAULT" | "SUCCESS" | "ERROR" | "LOADING"
    >("DEFAULT");

    const handleIgnore = () => {
        setMode("LOADING");

        let data = {
            extraction_id: id,
            user_id: localStorage.getItem("gim-user-id"),
            user_notes: notes,
            extraction_datetime: toAnalyticsDate(extraction_datetime),
            processing_datetime: toAnalyticsDate(processing_datetime),
        };

        Database.post("api/model_actions/ignore", data)
            .then((res) => {
                if (res.ok) {
                    setMode("SUCCESS");
                } else {
                    setMode("ERROR");
                }
            })
            .catch((err) => {
                setMode("ERROR");
            });
    };

    return (
        <Alert>
            <IgnoreExtractionModalContainer>
                {mode === "DEFAULT" && (
                    <>
                        <h2>IGNORE EXTRACTION</h2>
                        <p>
                            Are you sure you would like to ignore model errors
                            and process to the database?
                        </p>

                        {showNotes && (
                            <TextArea
                                value={notes}
                                change={setNotes}
                                placeholder="NOTES (OPTIONAL)"
                                rows={5}
                                label="NOTES"
                            />
                        )}

                        {!showNotes && (
                            <p
                                className="addNotesBtn"
                                onClick={() => setShowNotes(true)}
                            >
                                ADD NOTES
                            </p>
                        )}

                        <Button
                            text="IGNORE"
                            color="primary"
                            click={handleIgnore}
                        />
                        <Button
                            text="CANCEL"
                            color="flat"
                            click={() => setShowModal(false)}
                        />
                    </>
                )}

                {mode === "SUCCESS" && (
                    <>
                        <h2>EXTRACTION IGNORED</h2>
                        <p>Extraction has been ignored successfully.</p>
                        <Button
                            text="CLOSE"
                            color="primary"
                            click={() => {
                                reload();
                                setShowModal(false);
                            }}
                        />
                    </>
                )}

                {mode === "ERROR" && (
                    <>
                        <h2>ERROR</h2>
                        <p>There was a probelm ignoring the extraction.</p>

                        <Button
                            text="CLOSE"
                            color="primary"
                            click={() => setShowModal(false)}
                        />
                    </>
                )}

                {mode === "LOADING" && (
                    <>
                        <h2>IGNORING...</h2>
                        <p>In progress, may take a couple of minutes</p>
                    </>
                )}
            </IgnoreExtractionModalContainer>
        </Alert>
    );
}
